<template>
  <div class="header">
    <div class="head_top">
      <div class="logo"><a :href="webUrl" class="a-block"><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/pc_logo.png" alt=""></a></div>
      <!-- <div class="logo_right"> <img src="../assets/img/logo_right.png" alt=""> </div> -->
      <div class="ltitle login-new" v-if="title&&title!=''"><span class="lnth">{{title}}</span></div>
<!--      <div class="login-new" v-if="!user.token"><span @click="login">登录</span><span v-if="false">注册</span></div>-->
      <div class="links">
             <!-- <a href="http://www.china-aid.com" target="_blank" style="margin-left: 0;"><span>上海老博会（AID）</span></a> -->
             <a href="http://www.cdlc.cn/" target="_blank" style="margin-left: 10px;"><span>中国数字图书馆</span></a>
             <a href="http://www.sxjk365.com/" target="_blank" style="margin-left: 10px;"><span>健康365</span></a>
             <a href="http://www.sxnk110.com/" target="_blank" style="margin-left: 10px;"><span>农科110</span></a>
             <a v-if="$route.name=='Home'" :href="webUrl+'/beautifulCountry'" target="_blank" style="margin-left: 10px;"><span>2021美丽乡村博鳌国际峰会</span></a>
             <!-- <a  href="http://www.cdlc.cn/about/zwtsg.aspx" target="_blank"><span>政务图书馆</span></a> -->
      <!--       <a class="a-not" href="" target="_blank"> </a>-->
      <!--       <a href="" target="_blank" style="margin-right: 0;"> </a>-->
      </div>
      <div class="search-type">
          <div class="select-head" @click="changeSiteTitle">
              <span class="select-head-cont" >{{searchType}}</span>
              <img class="selct-img" src="../assets/img/select.png">
          </div>
          <ul class="option" v-show="options">
              <li class="option-item" @click="changeSite('百度')">百度</li>
              <li class="option-item" @click="changeSite('站内')">站内</li>
          </ul>
      </div>
      <div class="search">
       <!-- <div class="link">
          <a href="http://www.cdlc.cn/" target="_blank">中国数字图书馆</a>&nbsp;
          <a href="http://www.cdlc.cn/about/zwtsg.aspx" target="_blank">政务图书馆</a>
        </div> -->
        <input type="text" v-model="searchTxt" @keyup.enter="goSearch" placeholder="大家都在搜：少年的你">
        <div class="search_right"><i @click="goSearch" class="iconfont icon-fangdajing"></i></div>
        <div class="btn-search" @click="goSearch">搜索</div>
        <div class="date-lunar">{{currentDate}}  <span style="padding-left: 10px;">农历：{{currentLunarDate}}</span></div>
      </div>
    </div>

     <!-- 一级导航 -->
    <div class="nav nav-index" v-if="routePath=='/'"  :style="'z-index:'+(isShowNavOthers?3:0)+';'">
      <ul>
        <li @click="updateNav()"> <router-link active-class="active" to="/"  @click="goColumn"   exact>首页</router-link> </li>
        <!-- <li v-for="(item,i) in navList" v-if="item.codeEn!=='recommend'"> -->
        <li v-for="(item,i) in navList" v-if="i<33 && !item.outSiteTag && item.title!='1县1特'">
          <a :href="webUrl+'\/'+item.codeEn+'?id='+item._id+'.html&title='+item.title" @click="goColumn" :data-title="item.title" :class="item.codeEn===navType?'active':''" v-if="item.codeEn!=='renmindianshang'">
            {{item.title=='交通'?'数字交通':item.title}}
          </a>
          <a :href="webUrl+'\/infoPhantom'" rel="nofollow" target="_blank" v-else>{{item.title}}</a>
        </li>
        <!-- <li>
         <router-link to="/appDown">APP</router-link>
        </li> -->
        <li v-if="navList.length>=34" style="font-size: 20px;cursor: pointer;" @click="showNavOthers">{{isShowNavOthers==true?'×':'+'}}</li>
      </ul>
      <ul class="nav-others" ref="navOthers">
        <li v-for="(item,i) in navList" v-if="i>=33 && !item.outSiteTag"  :style="item.title.length>4?'width:0.46rem;':''">
          <a :href="webUrl+'\/'+item.codeEn+'?id='+item._id+'.html&title='+item.title" @click="goColumn" :data-title="item.title" :class="item.codeEn===navType?'active':''" v-if="item.codeEn!=='renmindianshang'">
            {{item.title}}
          </a>
          <a :href="webUrl+'\/infoPhantom'" rel="nofollow" target="_blank" v-else>{{item.title}}</a>
        </li>
      </ul>
    </div>
    <!-- 二级导航 -->
    <div class="nav" v-if="routePath!='/' && nav2&&nav2.length>0" style="height: 35px;">
      <ul class="second-nav-ul">
        <!-- 读书频道二级导航  首页 -->
        <li v-if="columnId=='5eb257451a760a707c12e955'"><a :href="webUrl+'/dushu?id=5eb257451a760a707c12e955.html&title=读书'" :class="routePath=='/dushu'?'active':''">读书首页</a></li>
        <!--  TODO set link  -->
        <li v-for="(item,i) in nav2" v-if="!item.outSiteTag" :style="item.title.length>4?'width:0.42rem;':''">
          <a v-if="item.parentId!='5eb257451a760a707c12e955'" href="#">{{item.title}}</a>
          <!-- 以下是 读书频道二级导航 -->
          <a v-if="item.codeEn=='yuedutoutiao'" :href="webUrl+'/readHeadlines?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/readHeadlines'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='xinshutuijian'" :href="webUrl+'/newBookRecommend?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/newBookRecommend'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='dushuhuodong'" :href="webUrl+'/readActivity?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/readActivity'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='quanminyuedu'" :href="webUrl+'/peopleRead?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/peopleRead'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='nongjiashuwu'" :href="webUrl+'/peasantBookRoom?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/peasantBookRoom'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='zaixiangoushu'" :href="webUrl+'/buyBooksOnline?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/buyBooksOnline'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='zhubiantuijian'" :href="webUrl+'/editorRecommendation?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/editorRecommendation'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='zhongwangwenxue'" :href="webUrl+'/zwLiterature?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/zwLiterature'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='yuedubangdan'" :href="webUrl+'/readRanking?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/readRanking'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='tushuzhuanti'" :href="webUrl+'/bookSpecial?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/bookSpecial'?'active':''">{{item.title}}</a>
          <a v-if="item.codeEn=='zhong shuo'" :href="webUrl+'/everyoneSay?id='+item.parentId+'.html&title='+item.title" :class="routePath=='/everyoneSay'?'active':''">{{item.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import {newsNav,webUrl,newsNav2,qzListColumn2} from '@/api';
  import {setStore} from "@/utils/storage";
  import {formatDate,lunarDate} from '@/utils/dateFormat';

  export default {
    inject: ["eventHub"],
    name: "Header",
    data() {
      return {
        webUrl,
        currentDate:'',
        currentLunarDate:'',
        title:'',
        columnId:'',
        navList: [],
        searchTxt: '',
        navType:'',
        isShowNavOthers: false,
        routePath:'',
        nav2:[],
        searchType:'百度',
        options: false

      }
    },
    computed:{
      ...mapState([
        'user'
      ])
    },
    watch: {
        $route(val) {
          // 路由懒加载后，需通过监听获取url
          this.routePath=val.path;
          // console.log('watch--this.$route');
          // console.log(this.$route);
          let route_title=this.$route.query.title;
          // this.title=localStorage.getItem("title");
          this.title=route_title;//?route_title:localStorage.getItem("title");
          if(this.routePath=='/bookDetail' || this.routePath=='/readHeadlines' || this.routePath=='/newBookRecommend' || this.routePath=='/readActivity' || this.routePath=='/peopleRead' || this.routePath=='/peasantBookRoom' || this.routePath=='/buyBooksOnline' || this.routePath=='/editorRecommendation' || this.routePath=='/zwLiterature' || this.routePath=='/readRanking' || this.routePath=='/bookSpecial' || this.routePath=='/everyoneSay'){
            this.title='读书';
          }
          //监听  文章详情面包屑导航
          this.eventHub.$on('on:title', (data) => {
            this.title=data;
            if(data==''){this.routePath="/";this.navType='';}
          })

          //监听  文章详情页,二级导航显示,需要columnId
          if(this.routePath=='/info'){
            this.eventHub.$on('update:columnId',(da)=>{
              // console.log('文章详情页,二级导航显示,需要columnId --- ' + da);
              this.columnId=da;
              newsNav2({columnId:this.columnId}).then(res=>{
                if(!res.code){
                    this.nav2=res.info;
                }
              })
            })
          }else{
            //  get subColumn
            this.columnId =this.$route.meta.queryId || this.$route.query.id?(this.$route.query.id.split('.')[0] || this.$route.query.id):'';
          }
          // 读书频道->书详情页, 添加读书导航，需要频道id（columnId）
          if(this.routePath=='/bookDetail'){
            this.columnId =this.$route.meta.columnId;
          }
          // console.log('columnId-------'+this.columnId);
          if(!!this.columnId)
            newsNav2({columnId:this.columnId}).then(res=>{
               // console.log(res.info);
              if(!res.code){
                  this.nav2=res.info;
              }
            });

            // 亲子频道,二级导航
            if(this.routePath=='/qinzi'){
              qzListColumn2({columnId:this.columnId}).then(res=>{
                 // console.log(res);
                if(!res.code){
                    this.nav2=res.info;
                }
              });
            }

        }
    },
    created() {
      // 监听,关闭导航下拉部分
      this.eventHub.$on('on:closeNav',(data)=>{
        // console.log('监听,关闭导航下拉部分 --- ' + data);
        if(data=="closeNav"){
          this.isShowNavOthers=false;
          this.$refs.navOthers.className='nav-others nav-others-default';
        }
      })

      this.currentDate=formatDate(new Date(),'yyyy年 MM月 dd日 www');
      this.currentLunarDate=lunarDate();

      // this.routePath=this.$route.path;
      // 路由懒加载后，需通过监听获取$route数据


      this.navType = window.location.pathname.replace('/','');
      newsNav().then(res => {
        if (!res.code) {
          // console.log(res.list);
            let arr=[];
            let tt='';
            for (var i = 0; i < res.list.length; i++) {
                tt=res.list[i].title;
                if(tt=='老区' || tt=='游戏' || tt=='电影' || tt=='动画' || tt=='中国制造' || tt=='农科110' || tt=='健康365'){
                   // console.log('频道'+tt);
                   continue;
                }
                 arr.push(res.list[i]);
            }
            // console.log(arr);
          this.navList = arr;
          setStore('nav', res.list)
        }
      })
    },
    methods: {
      ...mapActions(['POPUP_LOGIN','USER_SIGNOUT']),
      login() {
        this.POPUP_LOGIN(true);
      },
      goColumn(e){
        let title=e.currentTarget.dataset.title;
        localStorage.setItem("title",!title?"":title);
        // this.title=e.currentTarget.dataset.title
        // this.eventHub.$emit('on:title', !title?"":title)
      },
      goSearch() {
        if(this.searchType=="百度"){
          //百度联盟移动搜索，合作推广--- word 需要使用 utf-8编码并进行urlencode     实例：https://m.baidu.com/s?word=%E4%B8%A4%E4%BC%9A&from=1024325j
          // window.location.href='https://www.baidu.com/s?from=1024325j&word='+encodeURIComponent(this.searchTxt);
          window.open('https://www.baidu.com/s?from=1024325j&word='+encodeURIComponent(this.searchTxt));
        }else if(this.searchType=="站内"){
          this.$router.push({name: 'search', query: {wd: this.searchTxt}});
        }
      },
      updateNav() {
        this.navType = window.location.pathname.replace('/','');
      },
      showNavOthers(){
        this.isShowNavOthers=!this.isShowNavOthers;
        if(this.isShowNavOthers){
          this.$refs.navOthers.className='nav-others nav-others-active';
        }else{
          this.$refs.navOthers.className='nav-others nav-others-default';
        }
      },
      changeSiteTitle() {
        this.options = !this.options
      },
      changeSite(e) {
        this.searchType = e;
        this.options = false;
      }

    }
  }
</script>

<style scoped>
  .ltitle{
    font-size: 30px;
    /* float: left; */
    flex: 1;
    -webkit-flex: 1;
    height: 42px;
    /*position: relative;*/
    /*line-height: 130px;*/
    /* background-color: #ee0000cf; */
    /* color: white; */
    margin-top: 26px;
    padding: 2px;
    margin-left: 10px;
  }
  .header {
    width: 100%;
    /*height: 205px;*/
    background-color: white;
    clear: both;
  }

  .head_top {
    width: 1118px;
    height: 110px;
    margin: 0 auto;
  }

  .logo {
    width:267px;
    height:62px;
    margin-right: auto;
  }

  .logo img {
    width: 100%;
    height: 100%;
  }
  .search {
    width: 300px;/*no*/
    float: left;
    position: relative;
    /* margin-left: 20px; */
  }

  .search  .link a{
    color: #000 !important;
  }
  .search  .link{
    position: absolute;
    margin-top: 80px;

    border: none;
    border-radius: 19px;
    padding-left: 22px;
    box-sizing: border-box;
    transition: all ease-out 300ms;
    font-size: 12px;
    padding-right: 35px;
  }
  .search input {
    width:100%;
    height:34px;
    border:1px solid rgba(223,0,6,0.46);
    border-radius:5px;
    padding-left: 22px;
    color: #999999;
    box-sizing: border-box;
    transition: all ease-out 300ms;
    font-size: 14px;
    padding-left: 35px;
    margin-top: 23px;
  }

  .search input:focus {
    /*width: 358px;*/
  }

  .search_right {
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    left: 4px;
    top: 24px;
  }
  .search_right i {
    font-size: 14px;
    color: #9fa0a0;
    cursor: pointer;
  }
  .btn-search{
    width:43px;
    height:34px;
    line-height: 34px;
    text-align: center;
    background:rgba(223,0,6,1);
    border-radius:0px 5px 5px 0px;
    font-size:14px;
    font-weight:400;
    color:rgba(255,255,255,1);
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 23px;
  }

  .logo_right {
    width: 177px;
    height: 109px;
    float: right;
    margin-right:20px;

  }

  .logo_right img {
    width: 100%;
    height: 100%;
  }

  .nav {
    /* width: 100%; */
    width: 1118px;
    height: 60px;
    background-color: #e60012;
    position: relative;
    z-index: 1;
    /* padding-top: 7px; */
    padding: 4px 0;
    margin: 0 auto;
  }
  .nav-index{
    width: 100%;
  }
  .nav ul {
    width: 1118px;
    height: 100%;
    margin: 0 auto;
    padding: 0;
   /* display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap; */
  }
  .nav ul.second-nav-ul {
    display: flex;
     display: -webkit-flex;
     justify-content: space-between;
     -webkit-justify-content: space-between;
     align-items: center;
     -webkit-align-items: center;
     -webkit-flex-wrap: wrap;
     flex-wrap: wrap;
    justify-content: center;
    -webkit-justify-content: center;
  }
  .nav ul li {
    width: 65.6px;
    height: 28px;
    display: inline-block;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    color: #ffffff;
    font-size: 14px;
    overflow: hidden;
    float: left;
  }
  .nav ul.second-nav-ul li{
    width: auto;
    margin: 0 10px;
  }
  .nav ul li a {
    display: block;
    color: #ffffff;
    width: 100%;
    height: 100%;
  }
  .nav ul.second-nav-ul li a{
    width: auto;
    padding: 0 8px;
  }
  .nav ul li a:hover {
    background-color: #c81d1d;
    transition: all linear 300ms;
    color: #ffffff !important;
  }

  .active {
    background-color: #c81d1d;
  }

  .head_top{
    display: flex;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
    align-items: center;
    -webkit-align-items: center;
  }
  .login-new{
    /* margin-right: 236px; */
  }
  .head_top .login-new span.lnth{
    display: inline-block;
    width: auto;
    height: 100%;
    line-height: 42px;
    color: white;
    font-size: 30px;
    background-color: #ee0000cf;
    border-radius: 2px;
    margin-left: 0;
    padding: 0 10px;
  }
  .head_top .login-new span{
    display: inline-block;
    width:54px;
    height:26px;
    line-height:26px;
    text-align: center;
    background:rgba(245,245,245,1);
    font-size:14px;
    font-weight:400;
    color:rgba(63,63,63,1);
    margin-left:12px;
  }
.links{
  width: auto;
  padding: 7px 0 7px;
  display: flex;
  display: -webkit-flex;
  margin-right: 20px;
}
.links a{
  font-size:12px;
  font-weight:400;
  color:rgba(51,51,51,1);
  border-bottom: 1px solid transparent;
  /* padding-right: 20px;
  margin-right: 20px; */
}
.links a>span:hover{
  color: red;
  border-bottom: 1px solid #CC0000;
}
.links a.a-not{
  border-right: 1px solid #ECDFDF;
}
.nav ul.nav-others{
  height: 50px;
  background: rgba(248,247,247,1);
  box-sizing: border-box;
  padding-top: 11px;
  justify-content: left;
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  opacity: 0;
  display: none;
}
.nav ul.nav-others-active{
  display: block;
  opacity: 1;
  animation:myfirst 0.8s;
  -webkit-animation:myfirst 0.8s;
}
@keyframes myfirst
{
    0% {opacity: 0;}
    100% {opacity: 1;}
}
@-webkit-keyframes myfirst
{
    0% {opacity: 0;}
    100% {opacity: 1;}
}
.nav ul.nav-others-default{
  opacity: 0;
  animation:myfirst2 0.8s;
  -webkit-animation:myfirst2 0.8s;
}
@keyframes myfirst2
{
    0% {opacity: 1;}
    100% {opacity: 0;}
}
@-webkit-keyframes myfirst2
{
    0% {opacity: 1;}
    100% {opacity: 0;}
}
.nav ul.nav-others li a{
  /* width: 62px; */
  width: 100%;
  height: 28px;
  display: inline-block;
  color: #333333;
  font-size: 14px;
}
.date-lunar{
  color: #595959;
  font-size: 12px;
  padding-top: 10px;
}

/* 自定义下拉框样式 */
.search-type {
    padding: 0 6px;
    color: #666666;
    font-size: 14px;
    position: relative;
    cursor: pointer;
}
.selct-img {
    width: 16px;
}
.select-head {
    display: flex;
    align-items: center;
}
.select-head .select-head-cont {
    float: left;
}
.option {
    width: 80px;
    position: absolute;
    left: 0;
    background: #F2F2F2;
    z-index: 20000;
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.09);
    text-align: center;
    margin: 10px 0 0;
    padding: 0;
}
.option-item {
    border-bottom: .5px solid rgba(197, 197, 197, 0.27);
    height: 40px;
    line-height: 40px;
    list-style: none;
    border-bottom: 1px solid #FFFFFF;
}
.option-item:last-child {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue